import React, { lazy } from "react";
import Loadable from "../../components/Loadable";

const List = Loadable(lazy(() => import("./AbmComponents/List")));
const Update = Loadable(lazy(() => import("./AbmComponents/Update")));
const Show = Loadable(lazy(() => import("./AbmComponents/Show")));
const Create = Loadable(lazy(() => import("./AbmComponents/Create")));

const routes = [
  {
    path: "userType",
    element: <List />,
  },
  {
    path: "userType/update/:id",
    element: <Update />,
  },
  {
    path: "userType/create",
    element: <Create />,
  },
  {
    path: "userType/show/:id",
    element: <Show />,
  },
];
export default routes;
